import { render } from "./InterfaceMainMenu.vue?vue&type=template&id=d2c98594&scoped=true"
import script from "./InterfaceMainMenu.vue?vue&type=script&lang=js"
export * from "./InterfaceMainMenu.vue?vue&type=script&lang=js"

import "./InterfaceMainMenu.vue?vue&type=style&index=0&id=d2c98594&scoped=true&lang=scss"

import exportComponent from "/tmp/ee6909f6-e1a9-41e2-8541-cccc71f1c53b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c98594"]])

export default __exports__